import { SizeType, BUTTON_SIZE } from '@/constants/buttonSizes';
import { Icon } from '@/components/shared/atoms';

interface RoundedIconButtonProps {
  text: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  disabledClassName?: string;
  rounded?: string;
  size?: SizeType;
  icon?: string;
  iconClassName?: string;
  iconPosition?: 'left' | 'right';
}

const RoundedIconButton = ({ text, size, onClick, rounded = 'rounded', className = '', disabled = false, disabledClassName, icon, iconClassName, iconPosition = 'left' }: RoundedIconButtonProps) => {
  return (
    <button type="button" className={`${className} ${rounded} ${size && BUTTON_SIZE[size]} ${disabled && disabledClassName ? disabledClassName : ''}`} onClick={onClick} disabled={disabled}>
      {icon && iconPosition === 'left' && <Icon icon={icon} className={iconClassName} />}
      {text}
      {icon && iconPosition === 'right' && <Icon icon={icon} className={iconClassName} />}
    </button>
  );
};

export default RoundedIconButton;
